// extracted by mini-css-extract-plugin
export default {"wraperNavigation":"styles_wraperNavigation__jpEeZ","active":"styles_active__dPeZl"};